import { useEffect, useState } from "react";
import axios from "axios";
import { Percent } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PromoToggle({ token }) {
  const [p, setP] = useState(null);
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  useEffect(() => { axios.get(`${API}/admin/promo`, auth).then(({ data }) => setP(data)).catch(() => {}); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  if (!p) return null;
  const toggle = async () => {
    if (!window.confirm(p.active ? "Ukončiť zavádzaciu akciu? Noví uchádzači zaplatia za overenie plných 200 €." : "Spustiť zavádzaciu akciu? Každý nový uchádzač dostane zľavu 75 % na overenie (50 € namiesto 200 €).")) return;
    const { data } = await axios.post(`${API}/admin/promo`, { active: !p.active }, auth); setP(data);
  };
  return (
    <div className={`mb-5 flex flex-wrap items-center justify-between gap-3 border px-4 py-3 ${p.active ? "border-emerald-400/40 bg-emerald-500/5" : "border-white/10"}`} data-testid="promo-toggle">
      <p className="text-sm flex items-center gap-2">
        <Percent size={15} className="text-[#D4AF37]" />
        <span className="text-white">Zavádzacia akcia – online overenie −75 % (50 € namiesto 200 €)</span>
        <span className={p.active ? "text-emerald-300" : "text-white/40"} data-testid="promo-state">{p.active ? "· zapnutá" : "· vypnutá"}</span>
        <span className="text-white/40 text-xs">· v akcii zaregistrovaných: {p.count}</span>
      </p>
      <button onClick={toggle} data-testid="promo-toggle-btn"
        className={`px-4 py-2 text-sm font-semibold transition-colors ${p.active ? "border border-red-400/60 text-red-300 hover:bg-red-500/10" : "bg-[#D4AF37] text-black hover:bg-[#F2E3C6]"}`}>
        {p.active ? "Ukončiť akciu" : "Spustiť akciu"}
      </button>
    </div>
  );
}
